import apiClient from './client';
import { getAllPages } from './pagination';

// Flags on anything a user can question: `targetKind` is one of TARGET_KINDS
// (constants/targetKinds.js) and `flagType` one of FLAG_TYPES
// (constants/flagTypes.js). Each user has at most one flag of each type per target.

// {flag_type, description, created_by, mine}. `mine: true` lists only the
// viewer's own flags (the Add flag modal's pre-fill).
export const getFlags = (targetKind, id, { flagType, mine } = {}) =>
  getAllPages(`/${targetKind}/${id}/flags`, {
    ...(flagType ? { flag_type: flagType } : {}),
    ...(mine ? { mine: true } : {}),
  });

// Raise or update the viewer's flag. Returns {flag_counts}.
export const raiseFlag = (targetKind, id, flagType, description) =>
  apiClient.put(`/flags/${targetKind}/${id}/${flagType}`, { description }).then((r) => r.data);

export const removeFlag = (targetKind, id, flagType) =>
  apiClient.delete(`/flags/${targetKind}/${id}/${flagType}`).then((r) => r.data);
